import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

import { PlanZod } from 'types/zod/plan';

const MiscApi = {
    getPlans: strictQuery({
        In: z.void(),
        Out: z.array(PlanZod),
        handler: () => axios.get('/plans'),
    }),

    getBillingAndPaymentsLink: strictQuery({
        In: z.void(),
        Out: z.object({ redirect: z.string() }),
        handler: () => axios.get('/payments-portal'),
    }),

    getRoleHTMLTemplate: strictQuery({
        In: z.number(),
        Out: z.string(),
        handler: (id) => axios.get(`/roles/${id}/learn-more`),
    }),
};

export default MiscApi;
